import { render } from "./ArrowRight.vue?vue&type=template&id=3ffcf2e2"
import script from "./ArrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ffcf2e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ffcf2e2', __exports__)) {
    api.reload('3ffcf2e2', __exports__)
  }
  
  module.hot.accept("./ArrowRight.vue?vue&type=template&id=3ffcf2e2", () => {
    api.rerender('3ffcf2e2', render)
  })

}


export default __exports__